import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { ReactComponent as Frame } from 'assets/images/frame.svg';

const CustomSliderArrowWrapper = styled.button`
  border: none;
  background: none;

  &:hover {
    svg {
      path:first-of-type {
        fill: ${theme.colors.primary[400]};
      }
    }
  }
`;
const SliderCustomArrow = ({ className, style, onClick }) => {
  return (
    <CustomSliderArrowWrapper className={className} onClick={onClick} style={style} type="button">
      <Frame />
    </CustomSliderArrowWrapper>
  );
};

SliderCustomArrow.defaultProps = {
  className: '',
  style: {},
  onClick: () => {},
};
SliderCustomArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
};

export default SliderCustomArrow;
